import { render, staticRenderFns } from "./Trabajos.vue?vue&type=template&id=637f6a1d&"
import script from "./Trabajos.vue?vue&type=script&lang=js&"
export * from "./Trabajos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports